import React from "react";
import { Table, message, Card, Avatar, Typography, Tag } from "antd";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { UserOutlined } from "@ant-design/icons";
import useServerPagination from "Common/hooks/useServerPagination";

const { Text } = Typography;

// Fetch a page of learners from the paginated backend list API.
const fetchLearners = async ({ pageNumber, pageSize, orderByLatest }) => {
  const token = localStorage.getItem("token");
  const qs = new URLSearchParams({ pageNumber, pageSize, orderByLatest }).toString();
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/Learners/GetListAll?${qs}`,
    {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch learners");
  }

  return response.json();
};

const LearnersList = () => {
  const { items, loading, paginationProps } = useServerPagination(fetchLearners, {}, {
    onError: () => message.error("Failed to load learners data"),
  });

  const columns = [
    {
      title: "Learner",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            src={record.profileImage ? `${baseImageUrl}${record.profileImage}` : null}
            icon={!record.profileImage && <UserOutlined />}
            size="large"
            style={{
              backgroundColor: record.profileImage ? "transparent" : "#B17F14",
            }}
          />
          <Text strong>
            {record.firstName} {record.lastName}
          </Text>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Business Group",
      dataIndex: "businessGroupName",
      key: "businessGroupName",
      render: (text, record) => (record.hasBusinessGroup ? text : "N/A"),
    },
    {
      title: "Manager Assigned",
      dataIndex: "isManagerAssigned",
      key: "isManagerAssigned",
      render: (text, record) => (
        <Tag color={record.isManagerAssigned ? "green" : "red"}>
          {record.isManagerAssigned ? "Manager Assigned" : "Not Assigned"}
        </Tag>
      ),
    },
    {
      title: "Manager Name",
      dataIndex: "managerName",
      key: "managerName",
      render: (text) => (text ? text : "N/A"),
    },
  ];

  return (
    <Card className="card-professional" title="Learners List" variant="borderless">
      <Table
        columns={columns}
        dataSource={items}
        rowKey="learnerId"
        loading={loading}
        pagination={paginationProps}
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default LearnersList;
